if (!customElements.get('timeline-component')) {
  customElements.define('timeline-component', class TimelineComponent extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.timeline-scroll-container');
      this.prevBtn = this.querySelector('.timeline-arrow--prev');
      this.nextBtn = this.querySelector('.timeline-arrow--next');
    }

    connectedCallback() {
      if (!this.container) return;

      this.updateScrollAmount();

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scroll('next'));
      }

      if (this.prevBtn) { 
        this.prevBtn.addEventListener('click', () => this.scroll('prev'));
      }

      this.updateArrows();
      this.container.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateScrollAmount(), { passive: true });

      // Drag Functionality
      this.isDown = false;
      this.startX = 0;
      this.scrollStartX = 0;

      this.container.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.container.classList.add('is-dragging');
        this.startX = e.pageX - this.container.offsetLeft;
        this.scrollStartX = this.container.scrollLeft;
      });

      this.container.addEventListener('mouseleave', () => {
        this.isDown = false;
        this.container.classList.remove('is-dragging');
      });

      this.container.addEventListener('mouseup', () => {
        this.isDown = false;
        this.container.classList.remove('is-dragging');
      });

      this.container.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        e.preventDefault();
        const x = e.pageX - this.container.offsetLeft;
        const walk = (x - this.startX) * 2; // Scroll speed multiplier
        this.container.scrollLeft = this.scrollStartX - walk;
      });
    }

    updateScrollAmount() {
      const firstColumn = this.querySelector('.timeline-column');
      if (!firstColumn) {
        this.scrollAmount = 400;
        return;
      }

      this.scrollAmount = firstColumn.getBoundingClientRect().width;
    }

    scroll(direction) {
      const columns = Array.from(this.querySelectorAll('.timeline-column'));
      if (!columns.length) {
        const amount = direction === 'next' ? this.scrollAmount : -this.scrollAmount;
        this.container.scrollBy({ left: amount, behavior: 'smooth' });
        return;
      }

      const currentScroll = this.container.scrollLeft;
      const threshold = 10;
      let targetScroll = currentScroll;

      if (direction === 'next') {
        const nextCol = columns.find(col => col.offsetLeft > currentScroll + threshold);
        targetScroll = nextCol ? nextCol.offsetLeft : currentScroll + this.scrollAmount;
      } else {
        const prevCol = columns.slice().reverse().find(col => col.offsetLeft < currentScroll - threshold);
        targetScroll = prevCol ? prevCol.offsetLeft : Math.max(0, currentScroll - this.scrollAmount);
      }

      this.container.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn || !this.nextBtn) return;
      
      const scrollLeft = this.container.scrollLeft;
      const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

      // Disable prev button if at start
      if (scrollLeft <= 5) {
        this.prevBtn.setAttribute('disabled', 'disabled');
      } else {
        this.prevBtn.removeAttribute('disabled');
      }

      // Disable next button if at end
      if (scrollLeft >= maxScrollLeft - 5) {
        this.nextBtn.setAttribute('disabled', 'disabled');
      } else {
        this.nextBtn.removeAttribute('disabled');
      }
    }
  });
}